import { render, staticRenderFns } from "./Ment.vue?vue&type=template&id=2edb8c89&scoped=true"
import script from "./Ment.vue?vue&type=script&lang=js"
export * from "./Ment.vue?vue&type=script&lang=js"
import style0 from "./Ment.vue?vue&type=style&index=0&id=2edb8c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edb8c89",
  null
  
)

export default component.exports